var generateStyle = function generateStyle(componentTheme) {
  return {
    question: {
      border: "".concat(componentTheme.questionBorderWidth, " solid ").concat(componentTheme.questionBorderColor),
      borderRadius: componentTheme.questionBorderRadius,
      width: '100%',
      padding: '5px 20px 10px 20px',
      boxSizing: 'border-box',
      cursor: 'pointer'
    },
    header: {
      display: 'flex',
      flexDirection: 'column'
    },
    headerSection: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: '10px'
    },
    editButtons: {
      display: 'flex',
      justifyContent: 'flex-end',
      flex: '2 2 auto'
    },
    title: {
      color: componentTheme.titleColor,
      fontSize: componentTheme.titleFontSize,
      flex: '20 20 auto',
      margin: 0,
      marginLeft: '33px'
    },
    dragAndDrop: {
      flex: '1 1 auto'
    },
    itemBody: {
      marginLeft: '15px'
    },
    questionPosition: {
      flex: '1 1 0',
      alignItems: 'center',
      fontSize: '1.4rem',
      color: componentTheme.questionPositionColor
    },
    points: {
      display: 'flex',
      flex: '2 2 auto',
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingRight: '5px'
    },
    stem: {
      flex: '20 20 auto',
      alignItems: 'center',
      margin: 0,
      fontSize: '1.1rem'
    },
    legend: {
      border: 'none'
    },
    deleteButton: {
      backgroundColor: 'transparent',
      border: 'default',
      borderWidth: 'default',
      borderRadius: 'default',
      margin: 0,
      padding: 0
    },
    editButton: {
      backgroundColor: 'transparent',
      border: 'default',
      borderWidth: 'default',
      borderRadius: 'default',
      marginRight: '10px',
      padding: 0
    },
    itemDescription: {
      fontSize: componentTheme.itemBodyFontSize,
      fontWeight: componentTheme.itemBodyFontWeight
    },
    labelWrapper: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
};
export default generateStyle;